import { createContext } from 'utils/react-helpers';

const [ChecklistProvider, useChecklist] = createContext('ChecklistDetailsContext');

export { ChecklistProvider, useChecklist };
